<template>
  <div>
    <error customError="Error"></error>
  </div>
  <!-- <base-select class="mt-2" v-model="selectedVideoSource" label="label" :options="videoDevices" valueProp="deviceId"></base-select> -->
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
import Error from '@/components/video-launcher/Error'

export default {
  components: {
    BFormCheckbox,
    'base-select': () => import('@/components/base/forms/BaseSelect.vue'),
    Error
  },
  data () {
    return {
      videoDevices: [],
      selectedVideoSource: null,
      vmodel: false
    }
  },
  methods: {
    initDevices () {
      navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then((stream) => {
        navigator.mediaDevices.enumerateDevices().then((devices) => {
          const mappedDevices = devices.map((d) => {
            return {
              deviceId: d.deviceId,
              kind: d.kind,
              label: d.label,
              groupId: d.groupId
            }
          })
          this.videoDevices = mappedDevices.filter(d => d.kind === 'videoinput')
          this.selectedVideoSource = this.videoDevices[0].deviceId
        })
      })
    }
  },
  created () {
    this.initDevices()
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/views/testing/DeviceSelectorTesting.vue